import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'svc-work-order',
  templateUrl: './work-order.component.html',
  styleUrls: ['./work-order.component.scss']
})
export class WorkOrderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
